<template>
  <vx-card
    class="p-0"
    :title="$t('New_Message')"
  >
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      errorColor="rgba(var(--vs-danger), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
    >
      <tab-content
        title="Destinataires"
        class="mb-5"
        :before-change="Destinataires_validate"
      >
        <div v-if="seeError">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info" active="true" class="mt-5">
            <span> Veuillez choisir un élément parmi ces 4! <!-- <code>counter-danger.sync</code> --></span>
          </vs-alert><br>
        </div>

        <form data-vv-scope="Destinataires">
          <div class="vx-row">
            <div class="mb-4 vx-col md:w-1/2 w-full">
              <p>
                Niveaux
                <b style="color: #ff6141;">*</b>
              </p>
              <v-select
                multiple
                :closeOnSelect="false"
                :options="niveaus"
                :reduce="(rep) => rep.id"
                :clearable="true"
                label="libelle"
                v-model="niveaus_add"
                class="w-full"
              />
              <span class="text-danger">
                {{ errors.first('Personal_information.niveaus_add') }}
              </span>
            </div>
            <div class="mb-4 vx-col md:w-1/2 w-full">
              <p>
                Classes
                <b style="color: #ff6141;">*</b>
              </p>
              <v-select
                multiple
                :closeOnSelect="false"
                :options="classes"
                :reduce="(rep) => rep.id"
                :clearable="true"
                label="libelle"
                v-model="classes_add"
                class="w-full"
              />
              <span class="text-danger">
                {{ errors.first('Personal_information.sexe') }}
              </span>
            </div>
            <div class="mb-4 vx-col md:w-1/2 w-full">
              <p>
                Salles
                <b style="color: #ff6141;">*</b>
              </p>
              <v-select
                multiple
                :closeOnSelect="false"
                :options="salles"
                :reduce="(rep) => rep.id"
                :clearable="true"
                label="libelle"
                v-model="salles_add"
                class="w-full"
              />
              <span class="text-danger">
                {{ errors.first('Personal_information.sexe') }}
              </span>
            </div>
            <div class="mb-4 vx-col md:w-1/2 w-full">
              <p>
                Élèves
                <b style="color: #ff6141;">*</b>
              </p>
              <v-select
                multiple
                :options="inscriptions"
                :reduce="(rep) => rep.id"
                @search="getInscription"
                :clearable="true"
                :getOptionLabel="getOptionLabel"
                v-model="inscriptions_add"
                class="w-full"
              />
              <span class="text-danger">
                {{ errors.first('Personal_information.sexe') }}
              </span>

              <!-- 
                niveaus
                classes
                salles
                inscriptions
               -->
            </div>
          </div>
        </form>
      </tab-content>
      <tab-content
        title="Message"
        class="mb-5"
        :before-change="Message_validate"
      >
        <form data-vv-scope="Message">
          <div class="vx-row">
            <div class="mt-0 mb-4 vx-col md:w-1/2 w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-plus"
                label-placeholder="Titre du message"
                v-model="sortie.titre"
                @input="calculGeneral()"
                name="titre"
                v-validate="'required'"
              />
              <span class="text-danger">
                {{ errors.first('Message.titre') }}
              </span>
            </div>

            <div class="mb-4 vx-col md:w-1/2 w-full">
            </div>

            <div class="vx-col md:w-full w-full">
              <vs-textarea
                label="Contenu du message * ( 1 sms -> 160 Caractères)"
                v-model="sortie.contenu"
                @input="calculGeneral()"
                height="200px"
                name="contenu"
                v-validate="'required'"
              />
              <span class="text-danger">
                {{ errors.first('Message.contenu') }}
              </span>
            </div>
          </div>
        </form>

        <vs-list>
          <vs-list-header icon-pack="feather" icon="icon-send" title="Tous les Caractères"></vs-list-header>

          <vs-list-item icon-pack="feather" icon="icon-mail" title=" 1 SMS = 160 Caractères" subtitle="Cela signifie qu'un SMS peut contenir au maximum 160 caractères.">
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-message-circle" title="Nombre total de caractères saisis">
            <vs-chip color="#111183">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(nombreDeCaractereTotal) }}
              </b>
            </vs-chip>
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-message-square" title="Nombre de caractères restants" subtitle="C'est le nombre de caractères restants pour que l'SMS en cours soit plein.">
            <vs-chip color="warning">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(caracteresRestants) }}
              </b>
            </vs-chip>
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-at-sign" title="Nombre caractères en codage 7 bits" subtitle="Il s'agit du nombre total des caractères qui occupent l'espace de 2 caractères.">
            <vs-chip color="danger">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(nombreCaracteresEnCodage7Bits) }}
              </b>
            </vs-chip>
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-send" title="Nombre d'SMS (Par Parent)" subtitle="Il s'agit du nombre de SMS que contient votre message saisi.">
            <vs-chip color="success">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(nombreSMS) }}
              </b>
            </vs-chip>
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-users" title="Nombre de Parent">
            <vs-chip color="warning">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(nombreDeParent) }}
              </b>
            </vs-chip>
          </vs-list-item>

          <vs-list-item icon-pack="feather" icon="icon-send" title="Nombre total de SMS à envoyer">
            <vs-chip color="#111183">
              <b>
                {{ new Intl.NumberFormat('de-DE').format(nombreDeParent * nombreSMS) }}
              </b>
            </vs-chip>
          </vs-list-item>
        </vs-list>
      </tab-content>
      <div class="mb-8">
        <vs-alert color="primary" icon="new_releases" active="true" class="mt-5">
          <span>
            Note: Plusieurs caractères de ce codage 7 bits sont échappés, c'est-à-dire qu'ils occupent l'espace de 2 caractères. Ces caractères sont <code> { } [ ] | ^ ~ € </code>
          </span>
        </vs-alert>
      </div>
    </form-wizard>
  </vx-card>
</template>

<script>
let base_self = ''
import Datepicker from 'vuejs-datepicker'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// For custom error message
import { Validator } from 'vee-validate'

// Inscription
const input_tempon = {
  state: true,
  statutEleve: '',
  salle: '',
  anneeScolaire: '', // à sélectionner
  abandonAtente: false,
  abandon: false,
  enRegle: false,
  eleve: {
    rang: '',
    matricule: '',
    nom: '',
    prenoms: '',
    full_name: '',
    naissance: '',
    sexe: '',
    adresse: '',
    contact: '',
    dateEntree: '',
    parents_add: [
      {
        nom: '',
        prenoms: '',
        full_name: '',
        telephone1: '',
        telephone2: '',
        sexe: '',
        adresse: ''
      },
      {
        nom: '',
        prenoms: '',
        full_name: '',
        telephone1: '',
        telephone2: '',
        adresse: ''
      }
    ]
  }
}

export default {
  watch: {
    classes_add: {
      handler () {
        base_self.niveaus_add = []
      },
      deep: true
    },
    salles_add: {
      handler () {
        base_self.classes_add = []
        base_self.niveaus_add = []
      },
      deep: true
    },
    inscriptions_add: {
      handler () {
        base_self.salles_add = []
        base_self.classes_add = []
        base_self.niveaus_add = []
      },
      deep: true
    }
  },
  data () {
    return {
      nombreCaracteresEnCodage7Bits: 0,
      nombreSMS: 0,
      caracteresRestants: 0,
      nombreDeCaractereTotal: 0,
      nombreDeParent: 0,

      seeError: false,
      counterDanger: false,
      sortie: {
        titre: '',
        contenu: '',
        niveaus_add: [],
        classes_add: [],
        salles_add: [],
        inscriptions_add: []
      },
      niveaus: [],
      classes: [],
      salles: [],
      inscriptions: [],
      niveaus_add: [],
      classes_add: [],
      salles_add: [],
      inscriptions_add: [],
      paramInscription: {
        is_get: true,
        paginate: {
          length: 10,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false,
          anneeScolaire__cloture: false,
          anneeScolaire__encours: true
        },
        orderby: ['eleve__full_name'],
        juste: {
          id: '',
          eleve: {
            id: '',
            full_name: ''
          },
          salle: {
            libelle: '',
            classe: {
              id: '',
              niveau: {
                id: ''
              }
            }
          }
        }
      },
      // 
      loginError: {
        object: {},
        array: []
      },
      connexion: {
        1: {
          id: '',
          username: '',
          email: '',
          password: '',
          group_id: 6
        },
        2: {
          id: '',
          username: '',
          email: '',
          password: '',
          group_id: 6
        }
      },
      nomParent: {
        1: '',
        2: ''
      },
      prenomsParent: {
        1: '',
        2: ''
      },
      nomParent1: {
        1: '',
        2: ''
      },
      prenomsParent1: {
        1: '',
        2: ''
      },
      parentInfo: {
        1: null,
        2: null
      },
      radios1:'luis',
      parentExist: {
        1: false,
        2: false
      }, 
      dataImg: null,
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      ancienneSalle: '',
      newStudent: true,
      formwizard1: false,
      formwizard: false,
      desired: true,
      classe_input: {},
      frais_input: {},
      frais_input1: {},
      input_classes: [],
      popupActive: false,
      id_general: '',
      sexes: [],
      sexes1: [],
      statutEleves: []
    }
  },
  methods: {
    retournerLeNombreDeParent () {
      if (base_self.inscriptions_add.length) {
        base_self.sortie.inscriptions_add = base_self.inscriptions_add
      } else if (base_self.salles_add.length) {
        base_self.sortie.salles_add = base_self.salles_add
      } else if (base_self.classes_add.length) {
        base_self.sortie.classes_add = base_self.classes_add
      } else if (base_self.niveaus_add.length) {
        base_self.sortie.niveaus_add = base_self.niveaus_add
      }

      if (!base_self.sortie.id) {
        base_self.$http
          .post(`${base_self.$store.state.route_for_esm}message/SMS-nombre-de-parent`, base_self.sortie)
          .then((response) => {
            // console.log('response: ', response)
            base_self.nombreDeParent = response.data.nombre
            // window.getESM.success('Les messages sont envoyés avec succès.', response)
          })
          .catch((error) => {
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      }
    },
    calculGeneral () { // sortie.contenu
      const caracteresString = `${base_self.sortie.titre  }| ${  base_self.sortie.contenu}`
      const array = ['{', '}', '[', ']', '|', '^', '~', '€']
      let nombreCaracteresEnCodage7Bits = 0
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < caracteresString.length; j++) {
          if (array[i] === caracteresString[j]) {
            nombreCaracteresEnCodage7Bits++
          }
        }
      }

      const nombreCaracteresNonEnCodage7Bits = caracteresString.length - nombreCaracteresEnCodage7Bits
      base_self.nombreDeCaractereTotal = nombreCaracteresNonEnCodage7Bits + (nombreCaracteresEnCodage7Bits * 2)
      base_self.nombreCaracteresEnCodage7Bits = nombreCaracteresEnCodage7Bits
      base_self.nombreSMS = Math.ceil(base_self.nombreDeCaractereTotal / 160)
      base_self.caracteresRestants = (base_self.nombreSMS * 160) - base_self.nombreDeCaractereTotal
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 1000,
          page: 1
        },
        filter: { is_active: true },
        juste: {
          id: '',
          libelle: ''
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getNiveau (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 100,
          page: 1
        },
        filter: { is_active: true, libelle__icontains: search },
        juste: {
          id: '',
          libelle: ''
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 1000,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true },
        juste: {
          id: '',
          libelle: '',
          niveau: {
            id: ''
          }
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 100,
          page: 1
        },
        filter: {
          is_active: true,
          niveau__is_active: true,
          libelle__icontains: search
        },
        juste: {
          id: '',
          libelle: '',
          niveau: {
            id: ''
          }
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    deleteParent (item) {
      if (item.id) {
        if (base_self.input.eleve.parents_delete && base_self.input.eleve.parents_delete.length) {
          base_self.input.eleve.parents_delete.push(item.id)
        } else {
          base_self.input.eleve.parents_delete = [item.id]
        }
      }
    },
    async annuler (index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: 'Êtes vous sûr de vouloir créer un autre parent ayant les même imformations qu\'un parent existant ?',
        acceptText: 'Comfirmer',
        cancelText: 'Annuler',
        accept: async () => {
          base_self.parentExist[index + 1] = false
        }
      })
    },
    formatRechearch (ID, index) {
      if (base_self.nomParent[index] && base_self.prenomsParent[index]) {
        const full_name = `${ base_self.nomParent[index] } ${ base_self.prenomsParent[index] }`
        const data = {
          is_get: true,
          paginate: {
            length: 50,
            page: 1
          },
          filter: { full_name__icontains: full_name }
        }
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Parent`, data)
          .then((response) => {
            let ok = false

            for (let i = 0; i < response.data.data.length; i++) {
              const item = response.data.data[i]

              if (full_name.toLowerCase() === item.full_name.toLowerCase() && ID !== item.id) {
                base_self.parentInfo[index] = item
                ok = true
              }
            }

            if (ok) {
              base_self.parentExist[index] = true
            } else {
              base_self.parentExist[index] = false
            }
          })
          .catch((error) => {
            console.log('error: ', error)
          })
      }
    },
    getNumeroMatricule () {
      const data = {
        is_get: true,
        paginate: {
          length: 1,
          page: 1
        },
        filter: {},
        orderby: ['-id']
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Eleve`, data)
        .then((response) => {
          if (response.data.data.length) {
            base_self.input.eleve.rang = response.data.data[0].rang + 1
          } else {
            base_self.input.eleve.rang = 1
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    initConnexionInformation () {
      // setTimeout(() => {
      if (base_self.input.eleve.parents_add[0].user && base_self.input.eleve.parents_add[0].user.id) {
        base_self.connexion[1].id = base_self.input.eleve.parents_add[0].user.id
        base_self.connexion[1].username = base_self.input.eleve.parents_add[0].user.user.username
        base_self.connexion[1].password = ''
      } else {
        base_self.connexion[1].id = ''
        base_self.connexion[1].username = ''
        base_self.connexion[1].password = ''
      }
      // }, 1000)
    },
    validerFonction () {
      base_self.popupActive = false
      // base_self.formwizard1 = true
      base_self.initialiseElement()
    },
    errorsFirst (libelle, id, index) {
      return `step-${id}.${libelle}${index}`
    },
    getSexe1Simple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {}
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes1 = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSexe1 (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes1 = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getSexeSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {}
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSexe (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Sexe`, data)
        .then((response) => {
          base_self.sexes = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getStatutEleveSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {}
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}StatutEleve`, data)
        .then((response) => {
          base_self.statutEleves = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getStatutEleve (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}StatutEleve`, data)
        .then((response) => {
          base_self.statutEleves = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 1000,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          libelle__icontains: search
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getInscriptionSimple () {
      delete base_self.paramInscription.filter['eleve__full_name__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getInscription (search, loading) {
      loading(true)
      base_self.paramInscription.filter['eleve__full_name__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          base_self.inscriptions = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {
        // return `${option.eleve.full_name} ( ${option.salle.libelle} )`
        return `${option.eleve.full_name} ( ${option.salle.libelle} )`
      }
      return option
    },
    Destinataires_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('Destinataires').then((result) => {
          if (!base_self.niveaus_add.length && !base_self.classes_add.length && !base_self.salles_add.length && !base_self.inscriptions_add.length) {
            base_self.seeError = true
          } else {
            base_self.seeError = false
          }

          if (result && !base_self.seeError) {
            // base_self.submit()
            base_self.retournerLeNombreDeParent()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    // ************************************************************
    submitDataSimple () {
      return new Promise((resolve, reject) => {
        if (base_self.connexion[1].username.split(' ').length === 1 && base_self.connexion[1].username && base_self.connexion[1].password) {
          base_self.connexion[1].email = `parent${ base_self.connexion[1].username}${ base_self.connexion[1].password}@gmail.com`
          const input = JSON.parse(JSON.stringify(base_self.connexion[1]))

          if (!input.id) {     
            base_self.$http.post(`${base_self.$store.state.route_for_esm}Register/ProfileUtilisateur`, input)
              .then((response) => { 
                base_self.input.eleve.parents_add[0].user = response.data.id
                
                window.getESM.success('The users is added successfully.', response)
                resolve(true)
              })
              .catch((error) => {
                base_self.loginError.object = error.response.data
                base_self.loginError.array = Object.keys(error.response.data)         
                window.getESM.error('Une erreur est survenu l\'hors de l\'enrégistrement.')
                reject('Une erreur est survenu l\'hors de l\'enrégistrement.')
              })

          } else if (input.id) {
            base_self.$http.put(`${base_self.$store.state.route_for_esm}Register/ProfileUtilisateur`, input)
              .then((response) => {  
                base_self.input.eleve.parents_add[0].user = response.data.id

                window.getESM.success('The users is changed successfully.', response)
                resolve(true)
              })
              .catch((error) => {
                base_self.loginError.object = error.response.data
                base_self.loginError.array = Object.keys(error.response.data)      
                window.getESM.error('Une erreur est survenu l\'hors de l\'enrégistrement.')
                reject('Une erreur est survenu l\'hors de l\'enrégistrement.')
              })
          }
        } else {
          resolve(true)
        }
      })
    },
    Message_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('Message').then((result) => {
          if (result) {
            base_self.submit()
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    School_information_validate () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('School_information').then((result) => {
          base_self.submitDataSimple().then((rep) => {
            if (result && rep) {
              base_self.submit()
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
            .catch(() => {
              reject('correct all values')
            })
        })
      })
    },
    compterSalle (input, libelle, response) {
      window.getESM.mettreAJourUneSalle(input.salle)
        .then(() => {
          if (base_self.ancienneSalle && base_self.ancienneSalle !== input.salle) {
            window.getESM.mettreAJourUneSalle(base_self.ancienneSalle)
              .then(() => {
                window.getESM.success(base_self.$t(libelle), response)
                base_self.$vs.loading.close()
                base_self.$router.push('/Student_management/Student/main/0').catch(() => {})
              })
              .catch(() => {
                window.getESM.error(base_self.$t('The_server_is_not_responding'))
              })
          } else {
            window.getESM.success(base_self.$t(libelle), response)
            base_self.$vs.loading.close()
            base_self.$router.push('/Student_management/Student/main/0').catch(() => {})
          }
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    async submit () {
      if (base_self.inscriptions_add.length) {
        base_self.sortie.inscriptions_add = base_self.inscriptions_add
      } else if (base_self.salles_add.length) {
        base_self.sortie.salles_add = base_self.salles_add
      } else if (base_self.classes_add.length) {
        base_self.sortie.classes_add = base_self.classes_add
      } else if (base_self.niveaus_add.length) {
        base_self.sortie.niveaus_add = base_self.niveaus_add
      }

      if (!base_self.sortie.id) {
        base_self.$http
          .post(`${base_self.$store.state.route_for_esm}message/envoyer-SMS-au-parent`, base_self.sortie)
          .then((response) => {
                
            window.getESM.success('Les messages sont envoyés avec succès.', response)
          })
          .catch((error) => {
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      }
    },
    async getTypeFraiss () {
      const param = {
        is_get: true,
        filter: {}
      }

      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}TypeFrais`, param)
        .then((response) => {
          base_self.typeFraiss = response.data.data
          base_self.initialiseElement()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          base_self.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  },
  created () {
    base_self = this

    base_self.getNiveauSimple()
    base_self.getClasseSimple()
    base_self.getSalleSimple()
    base_self.getInscriptionSimple()

    ///////////////////////////
    const dict = {
      custom: {
        naissance: {
          required: base_self.$t('The_Date_of_Birth_is_required')
        },
        sexe: {
          required: base_self.$t('The_sex_is_required')
        },
        nom: {
          required: base_self.$t('The_Last_name_is_required')
        },
        prenoms: {
          required: base_self.$t('The_First_names_is_required')
        },
        adresse: {
          required: base_self.$t('The_Address_is_required')
        },
        telephone1: {
          required: base_self.$t('The_Phone_number_1_is_required')
        },
        dateEntree: {
          required: base_self.$t('The_Entry_date_is_required')
        },
        statutEleve: {
          required: base_self.$t('The_Student_status_is_required')
        },
        salle: {
          required: base_self.$t('The_Classroom_is_required')
        }
      }
    }
    // register custom messages
    Validator.localize('en', dict)
    //////////////////////////

    const id = Number(base_self.$route.params.id)
    if (id !== 0) {
      base_self.newStudent = false
    }
  }
}
</script>

<style>
.usernamepassword1 {
  border: solid 0.3em;
  width: auto;
  margin: 1px;
  padding: 60px;
  border-color: rgb(255, 123, 0);
  border-radius: 50% 20% / 10% 40%;
  background-color: rgb(255, 123, 0);
}
.usernamepassword2 {
  border: solid 0.3em;
  width: auto;
  margin: 1px;
  padding: 60px;
  border-color: #7367f0;
  border-radius: 50% 20% / 10% 40%;
  background-color: #7367f0;
}
.vsradiocustom {
  margin-top: -21px;
}

[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
